export default __webpack_public_path__ + "static/media/detail_mobile_1_2.b889bd3f.png";